import React, { useState, useContext } from 'react';
import { useIntl } from 'react-intl';
import { FiEdit } from 'react-icons/fi';

import { UserContext } from '~contexts/user';
import PhoneModal from './modal';

import './style.scss';

const Phone = () => {
  const intl = useIntl();

  const { user, isLoading } = useContext(UserContext);
  const phoneNumber = user.phoneNumber || '';
  const [isModalOpened, setIsModalOpened] = useState(false);

  if (isLoading) return null;

  return (
    <div className="c-box">
      <div className="c-box__content">
        <div className="c-editable">
          <div className="c-editable__content">
            <h3 className="l-headline--tertiary c-box__headline">
              {intl.formatMessage({ id: 'containers.account.phone.headline', defaultMessage: 'Phone number' })}
            </h3>
          </div>
          <button type="button" className="c-editable__button" data-cy="c-phone-editable__button" aria-label={intl.formatMessage({ id: 'common.edit', defaultMessage: 'Edit' })} onClick={() => setIsModalOpened(true)}>
            <FiEdit aria-hidden="true" />
          </button>
        </div>

        {!phoneNumber ? (
          <>
            <div className="c-editable">
              <div className="c-editable__content">
                <div className="c-account__value">
                  {intl.formatMessage({
                    id: 'containers.account.phone.no-numbers',
                    defaultMessage: 'You have not added any phone number yet.',
                  })}
                </div>
              </div>
            </div>
            <div className="c-editable">
              <div className="c-editable__content">
                <button type="button" className="c-btn--text" onClick={() => setIsModalOpened(true)}>
                  {intl.formatMessage({ id: 'containers.account.phone.add-phone', defaultMessage: 'Add phone number' })}
                </button>
              </div>
            </div>
          </>
        ) : null}

        {phoneNumber ? (
          <div className="c-editable">
            <div className="c-editable__content">
              <div className="c-account__value">{phoneNumber}</div>
            </div>
          </div>
        ) : null}
      </div>
      <PhoneModal isOpened={isModalOpened} onToggle={setIsModalOpened} />
    </div>
  );
};

export default Phone;
